// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper__fxzgjwJgsmV3F"};